import RoutesList from './components/RoutesList/RoutesList';
import Footer from './components/ui/footer';
import Header from './components/ui/header';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


function App() {
    const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="App">
      <Header />
      <RoutesList />
      <Footer />
    </div>
  );
}

export default App;
